import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'md-file-list',
  template: require('./file-list.component.html'),
  styles: [require('./file-list.component.scss')]
})

export class FileListComponent {

  @Input() list = [];
  @Output() removeEmitter = new EventEmitter();

  ngOnInit() {
  }

  remove(item) {
    this.removeEmitter.emit(item);
  }

}
